// src/features/townBudget/components/programs/Program_TaxRevenues.jsx

import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

/**
 * Town Program: Tax Revenues
 *
 * Firestore docId should match your stored doc:
 *   revenues_tax_revenues
 */
export const PROGRAM_TAX_REVENUES_CONFIG = {
  fullName: "Tax Revenues",
  docId: "revenues_tax_revenues",

  fieldDefs: [
    {
      key: "currentLevy",
      label: "Current Levy",
      valueType: "currency",
      sources: [{ block: "Tax Revenues", key: "Current Levy" }],
      group: "taxLevy",
      defaultVisible: true,
    },
    {
      key: "autoSupplemental",
      label: "Auto Supplemental",
      valueType: "currency",
      sources: [{ block: "Tax Revenues", key: "Auto Supplemental" }],
      group: "motorVehicle",
      defaultVisible: true,
    },
    {
      key: "delinquentMotorVehicleFees",
      label: "Delinquent Motor Vehicle Fees",
      valueType: "currency",
      sources: [{ block: "Tax Revenues", key: "Delinquent Motor Vehicle Fees" }],
      group: "delinquentFees",
      defaultVisible: false,
    },
    {
      key: "priorYears",
      label: "Prior Years",
      valueType: "currency",
      sources: [{ block: "Tax Revenues", key: "Prior Years" }],
      group: "delinquentFees",
      defaultVisible: false,
    },
    {
      key: "interestFees",
      label: "Interest & Fees",
      valueType: "currency",
      sources: [{ block: "Tax Revenues", key: "Interest & Fees" }],
      group: "delinquentFees",
      defaultVisible: true,
    },
    {
      key: "miscFees",
      label: "Miscellaneous Fees",
      valueType: "currency",
      sources: [{ block: "Tax Revenues", key: "Miscellaneous Fees" }],
      group: "delinquentFees",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "adopted",
      title: "Tax Revenues – Approved",
      sectionKey: "Approved",
      fields: [
        "currentLevy",
        "autoSupplemental",
        "delinquentMotorVehicleFees",
        "priorYears",
        "interestFees",
        "miscFees",
      ],
      columnStyles: {
        year: { width: "90px", minWidth: "90px" },
        currentLevy: { minWidth: "160px" },
        autoSupplemental: { minWidth: "140px" },
        delinquentMotorVehicleFees: { minWidth: "170px" },
        priorYears: { minWidth: "120px" },
        interestFees: { minWidth: "130px" },
        miscFees: { minWidth: "160px" },
      },
    },
    {
      id: "actual",
      title: "Tax Revenues – Actual",
      sectionKey: "Actual",
      fields: [
        "currentLevy",
        "autoSupplemental",
        "delinquentMotorVehicleFees",
        "priorYears",
        "interestFees",
        "miscFees",
      ],
      columnStyles: {
        year: { width: "90px", minWidth: "90px" },
        currentLevy: { minWidth: "160px" },
        autoSupplemental: { minWidth: "140px" },
        delinquentMotorVehicleFees: { minWidth: "170px" },
        priorYears: { minWidth: "120px" },
        interestFees: { minWidth: "130px" },
        miscFees: { minWidth: "160px" },
      },
    },
  ],

  chartTitle: "Tax Revenue Line Tax Revenues (Actual preferred)",
};

export function ProgramTaxRevenues(props) {
  return (
    <ProgramBudget
      programId="revenues_tax_revenues"
      config={PROGRAM_TAX_REVENUES_CONFIG}
      {...props}
    />
  );
}
